const initialState = {
	data: [],
	total: 0,
	params: {},
}

const fraudip = (state = initialState, action) => {
	switch (action.type) {
		case 'FRAUDIP_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		default:
			return state
	}
}

export default fraudip
